module.exports = __webpack_public_path__ + "img/1.4e03cee0.jpg";